import React from "react";

const ListofSaleCounters = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>List of Sale Counters</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th colspan="7"> List of HSDC Sale Counters on 13-10-2023 </th>
              </tr>
              <tr>
                <th>Regional Unit</th>
                <th>Sr. No.</th>
                <th>Name of Sale Counter</th>
                <th>Name of the Official (S/Sh.)</th>
                <th>Designation</th>
                <th>Mobile No.</th>
                <th>Address</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="14">UMRI</td>
                <td>1</td>
                <td>UMRI</td>
                <td>VIRENDER SINGH</td>
                <td>DPL</td>
                <td>9896168055</td>
                <td>HSDC Complex Umri</td>
              </tr>
              <tr>
                <td>2</td>
                <td>LADWA</td>
                <td>VINAY KUMAR</td>
                <td>DPL</td>
                <td>8529487226</td>
                <td>Near Anaj Mandi, Radour Road Ladwa </td>
              </tr>
              <tr>
                <td>3</td>
                <td>SAHABAD</td>
                <td>NARESH KUMAR</td>
                <td>DPL</td>
                <td>9050449884</td>
                <td>New Anaj Mandi Barara Road Shahabad</td>
              </tr>
              <tr>
                <td>4</td>
                <td>ISMAILABAD</td>
                <td>SANDEEP SINGH</td>
                <td>DPL</td>
                <td>8607546648</td>
                <td>Opp. Grain Market Ismailabad</td>
              </tr>
              <tr>
                <td>5</td>
                <td>PEHOWA</td>
                <td>SUSHIL KUMAR</td>
                <td>CLERK</td>
                <td>8930882323</td>
                <td>Near Bus Stand, Super Market Pehowa, KKR</td>
              </tr>
              <tr>
                <td>6</td>
                <td>KAITHAL</td>
                <td>MOHIT KUMAR</td>
                <td>DPL</td>
                <td>7988356009</td>
                <td>
                  Old Chungi, Near Mahaveer jain Chowk, Jind Road, Kaithal
                </td>
              </tr>
              <tr>
                <td>7</td>
                <td>PUNDRI</td>
                <td>ISHWER SINGH</td>
                <td>DPL</td>
                <td>9068430005</td>
                <td>Shop No. 106, Old Anaj Mandi Pundri</td>
              </tr>
              <tr>
                <td>8</td>
                <td>CHEEKA</td>
                <td>SANDEEP SINGH</td>
                <td>DPL</td>
                <td>9992346775</td>
                <td>Jai Jagdish Market, Near Swaraj Tractor Agency, Cheeka</td>
              </tr>
              <tr>
                <td>9</td>
                <td>KALAYAT</td>
                <td>VISHNU DUTT</td>
                <td>DPL</td>
                <td>9068907438</td>
                <td>Near Bansal Hospital, Railway Road, Kalayat</td>
              </tr>
              <tr>
                <td>10</td>
                <td>KARNAL</td>
                <td>CHARAN SINGH</td>
                <td>CLERK</td>
                <td>9817258968</td>
                <td>Shop No. 11- A Near Chaman Garden, Karnal</td>
              </tr>
              <tr>
                <td>11</td>
                <td>GHAROUNDA</td>
                <td>SANDEEP SINGH</td>
                <td>DPL</td>
                <td>9813666366</td>
                <td>Shop No. 221, New Grain Market Gharounda</td>
              </tr>
              <tr>
                <td>12</td>
                <td>ASSANDH</td>
                <td>DEEPAK </td>
                <td>DPL</td>
                <td>9467353948</td>
                <td>Near Tehsil, Kondh Road, Assandh</td>
              </tr>
              <tr>
                <td>13</td>
                <td>PANIPAT</td>
                <td>UDIT TYAGI</td>
                <td>DPL</td>
                <td>7988884313</td>
                <td>Shop No. 28 New Anaj Mandi Panipat, Distt. Panipat</td>
              </tr>
              <tr>
                <td>14</td>
                <td>SAMALKHA</td>
                <td>VINIT SAROHA</td>
                <td>DPL</td>
                <td>9717598784</td>
                <td>Shop No. 72 New Anaj Mandi Samalkha</td>
              </tr>
              <tr>
                <td rowspan="15">PATAUDI</td>
                <td>15</td>
                <td>NARNAUL</td>
                <td>AMIT KUMAR</td>
                <td>SALESMAN</td>
                <td>9416437565</td>
                <td>
                  Kailash Nagar, Rewari Road, Narnaul, Distt. Mahendergarh
                </td>
              </tr>
              <tr>
                <td>16</td>
                <td>MAHENDERGARH</td>
                <td>SUNIL KUMAR</td>
                <td>DPL</td>
                <td>9467667565</td>
                <td>Gate No.-2, New Anaj Mandi, Mahendergarh</td>
              </tr>
              <tr>
                <td>17</td>
                <td>KANINA</td>
                <td>RAVI </td>
                <td>DPL</td>
                <td>9050535834</td>
                <td>Ateli Mode, Mahendergarh Road, Kanina</td>
              </tr>
              <tr>
                <td>18</td>
                <td>REWARI</td>
                <td>SATYAPAL</td>
                <td>DPL</td>
                <td>9416178001</td>
                <td>Shop No.41, New Anaj Mandi, Rewari</td>
              </tr>
              <tr>
                <td>19</td>
                <td>KOSLI</td>
                <td>SUSHIL KATARIA</td>
                <td>DPL</td>
                <td>8059972283</td>
                <td>Near Market Society, Railway Road, Kosli, Distt-Rewari</td>
              </tr>
              <tr>
                <td>20</td>
                <td>HAILY MANDI</td>
                <td>SUNIL KUMAR</td>
                <td>DPL</td>
                <td>9996761655</td>
                <td>Opp. Shri Ram Chowk, Haily Mandi, Distt - Gurugram</td>
              </tr>
              <tr>
                <td>21</td>
                <td>SOHNA</td>
                <td>RAJESH KUMAR</td>
                <td>DPL</td>
                <td>8053272240</td>
                <td>Mandhkola road Sohna (Distt- Gurugarm)</td>
              </tr>
              <tr>
                <td>22</td>
                <td>FARRUKH NAGAR</td>
                <td>SANJAY</td>
                <td>PEON </td>
                <td>9340322230</td>
                <td>
                  Shop No. 11, New Anaj Mandi, Farrukhnagar, Distt-Gurugram
                </td>
              </tr>
              <tr>
                <td>23</td>
                <td>PALWAL</td>
                <td>SOHAN PAL</td>
                <td>DPL</td>
                <td>9671119329</td>
                <td>
                  New Anaj Mandi, Near Railway Station, Palwal, Distt-Palwal
                </td>
              </tr>
              <tr>
                <td>24</td>
                <td>HODAL</td>
                <td>SAHID AHMAD</td>
                <td>DPL</td>
                <td>9518072763</td>
                <td>Delhi Agra Old GT Road, Hodal, Distt-Palwal</td>
              </tr>
              <tr>
                <td>25</td>
                <td>BALLABHGARH</td>
                <td>SANDEEP KUMAR </td>
                <td>DPL</td>
                <td>9654446555</td>
                <td>C-486 Chawla Colony, Ballabhgarh, Distt-Faridabad</td>
              </tr>
              <tr>
                <td>26</td>
                <td>TAURU</td>
                <td>PAWAN KUMAR</td>
                <td>DPL</td>
                <td>9812386700</td>
                <td>Mohmadpur Ahir Road, Tauru, Distt-Mewat</td>
              </tr>
              <tr>
                <td>27</td>
                <td>PUNHANA</td>
                <td>TAYUB HUSSAIN</td>
                <td>DPL</td>
                <td>9034738063</td>
                <td>Jamalgarh Road Punhana (Distt-Nuh)</td>
              </tr>
              <tr>
                <td>28</td>
                <td>NUH</td>
                <td>ABDUL HAI</td>
                <td>DPL</td>
                <td>9813289172</td>
                <td>
                  Mewli Khedla road nearby Jhanda Park, Nuh,Distt - Mewat{" "}
                </td>
              </tr>
              <tr>
                <td>29</td>
                <td>PATAUDI CAMPUS</td>
                <td>GAURAV</td>
                <td>PEON </td>
                <td>7988735390</td>
                <td>Narhera Road, Pataudi (Gurugram)</td>
              </tr>
              <tr>
                <td rowspan="10">YAMUNA NAGAR</td>
                <td>30</td>
                <td>Y. NAGAR</td>
                <td>ANKUSH</td>
                <td>DPL</td>
                <td>8950868708</td>
                <td>M-5 Industrial area Yamuna Nagar</td>
              </tr>
              <tr>
                <td>31</td>
                <td>JAGADHRI</td>
                <td>MuNISH KUMAR </td>
                <td>DPL</td>
                <td>9996662200</td>
                <td>Buria Chowk Amadalpur Road, Jagadhri</td>
              </tr>
              <tr>
                <td>32</td>
                <td>RADAUR</td>
                <td>VIPUL POSWAL </td>
                <td>DPL</td>
                <td>9671140420</td>
                <td>Ladwa Road, Radaur</td>
              </tr>
              <tr>
                <td>33</td>
                <td>NARAINGARH</td>
                <td>GOPAL SHARMA</td>
                <td>DPL</td>
                <td>7015656294</td>
                <td>Shop No. 56, Grain Market, Naraingarh</td>
              </tr>
              <tr>
                <td>34</td>
                <td>AMBALA</td>
                <td>AMIT KUMAR </td>
                <td>DPL</td>
                <td>9354642367</td>
                <td>Shop No. 34, New Grain Market, Ambala City</td>
              </tr>
              <tr>
                <td>35</td>
                <td>BARARA</td>
                <td>Ram Sharan</td>
                <td>Jr. Mech.</td>
                <td>8816897158</td>
                <td>Booth No. 171 Anaj Mandi Barara</td>
              </tr>
              <tr>
                <td>36</td>
                <td>SADHOURA</td>
                <td>ASHISH </td>
                <td>DPL</td>
                <td>9050656345</td>
                <td>Booth No. 17 & 18, Anaj Mandi, opp. Bus stand Sadhoura</td>
              </tr>
              <tr>
                <td>37</td>
                <td>LEDI</td>
                <td>SANDEEP KUMAR </td>
                <td>DPL</td>
                <td>9416447334</td>
                <td>Kot Road, Near Jal Ghar, Ledi</td>
              </tr>
              <tr>
                <td>38</td>
                <td>PINJORE</td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  Saini Wali Gali, Near Ravidas Mandir, Nalagarh road , Pinjore{" "}
                </td>
              </tr>
              <tr>
                <td>39</td>
                <td>BARWALA</td>
                <td>NILESH KUMAR</td>
                <td>DPL</td>
                <td>9671482495</td>
                <td>Near Bus Stand, Durga Market Barwala</td>
              </tr>
              <tr>
                <td rowspan="6">HISAR</td>
                <td>40</td>
                <td>UKLANA</td>
                <td>NARESH KUMAR</td>
                <td>DPL</td>
                <td>9416581309</td>
                <td>Shop No. 5, Near Sangwan Hospital Approach Road Uklana </td>
              </tr>
              <tr>
                <td>41</td>
                <td>ADAMPUR</td>
                <td>SATBIR SINGH</td>
                <td>DPL</td>
                <td>9255292313</td>
                <td>Shop No-SCF-8 Additional Anaj Mandi, Adampur</td>
              </tr>
              <tr>
                <td>42</td>
                <td>BARWALA</td>
                <td>SONU</td>
                <td>DPL</td>
                <td>7988005053</td>
                <td>Shop No. 604 Opp. Durga Mandir, Barwala</td>
              </tr>
              <tr>
                <td>43</td>
                <td>HISAR</td>
                <td>SUSHIL KUMAR</td>
                <td>DPL</td>
                <td>7988977356</td>
                <td>Shop No. 15, New Grain Mkt. Hisar</td>
              </tr>
              <tr>
                <td>44</td>
                <td>NARNAUND</td>
                <td>RAKESH</td>
                <td>CLERK</td>
                <td>9728827956</td>
                <td>Shop No. 62 Opp. Grain Market Near Bus Stand, Narnaund</td>
              </tr>
              <tr>
                <td>45</td>
                <td>HANSI</td>
                <td>ROHIT</td>
                <td>DPL</td>
                <td>8685867984</td>
                <td>Gandhi Market, Near Bus Stand Hansi</td>
              </tr>
              <tr>
                <td rowspan="10">TOHANA</td>
                <td>46</td>
                <td>TOHANA MANDI </td>
                <td>SANJAY KUMAR</td>
                <td>CLERK</td>
                <td>8607576321</td>
                <td>Near Kainchi Chowk, Tohana City</td>
              </tr>
              <tr>
                <td>47</td>
                <td>TOHANA COMPLEX</td>
                <td>ASHOK KUMAR</td>
                <td>DPL </td>
                <td>8168210930</td>
                <td>HSDC, Complex Dangra Road Tohana(C)</td>
              </tr>
              <tr>
                <td>48</td>
                <td>FATEHABAD</td>
                <td>RAHUL BRAR</td>
                <td>DPL</td>
                <td>9416548580</td>
                <td>Shri Ram Sewa Samiti Opp. Bus Stand, Fatehabad</td>
              </tr>
              <tr>
                <td>49</td>
                <td>RATIA</td>
                <td>RAKESH KUMAR</td>
                <td>DPL</td>
                <td>9416255931</td>
                <td>Huda Complex Shop No.8, Ratia</td>
              </tr>
              <tr>
                <td>50</td>
                <td>BHUNA</td>
                <td>RAMESH KUMAR</td>
                <td>SALESMAN</td>
                <td>9416152561</td>
                <td>Luxmi gate, Near Aaj Mandi, Bhuna</td>
              </tr>
              <tr>
                <td>51</td>
                <td>JIND</td>
                <td>VIRENDER KUMAR</td>
                <td>DPL</td>
                <td>8930930946</td>
                <td> Opp. Gate No.2, Shop No. 36B, New Anaj Mandi, Jind</td>
              </tr>
              <tr>
                <td>52</td>
                <td>NARWANA</td>
                <td>Ram Baj</td>
                <td>DPL</td>
                <td>8168282121</td>
                <td>Opposite LIC Office, Narwana</td>
              </tr>
              <tr>
                <td>53</td>
                <td>UCHANA</td>
                <td>BALRAJ SINGH</td>
                <td>DPL</td>
                <td>9728010208</td>
                <td>40 Foota Road Near Anaj Mandi, Uchana</td>
              </tr>
              <tr>
                <td>54</td>
                <td>JULANA</td>
                <td>PARDEEP KUMAR</td>
                <td>CLERK</td>
                <td>8930493222</td>
                <td>Durga Mandir Wali Gali Near OBC Bank, Julana</td>
              </tr>
              <tr>
                <td>55</td>
                <td>SAFIDON</td>
                <td>VIKASH</td>
                <td>PEON</td>
                <td>7988516514</td>
                <td>Hatt Road Near Old Anaj Mandi Gate, Safidon</td>
              </tr>
              <tr>
                <td rowspan="6">SIRSA</td>
                <td>56</td>
                <td>SIRSA MANDI</td>
                <td>RAKESH KUMAR</td>
                <td>DPL</td>
                <td>9468014039</td>
                <td>Shop no. 76, Janta Bhawan Road, Opp. HDFC bank, Sirsa</td>
              </tr>
              <tr>
                <td>57</td>
                <td>SIRSA COMPLEX</td>
                <td>RAGHAV GOYAL</td>
                <td>DPL</td>
                <td>7015310775</td>
                <td>4TH Mile Stone Hisar Road, Sirsa</td>
              </tr>
              <tr>
                <td>58</td>
                <td>ELLENABAD</td>
                <td>AJAY KUMAR</td>
                <td>DPL</td>
                <td>9728490051</td>
                <td>Shop No. 73-B, New Anaj Mandi, Ellenabad</td>
              </tr>
              <tr>
                <td>59</td>
                <td>KALANWALI</td>
                <td>RAVINDER BENIWAL</td>
                <td>DPL</td>
                <td>9066500094</td>
                <td>Modal Town, SBI Street, Kalanwali</td>
              </tr>
              <tr>
                <td>60</td>
                <td>DABWALI</td>
                <td>ANIL POONIA</td>
                <td>DPL</td>
                <td>7220811505</td>
                <td>Booth No.78, B-Block, Dabwali</td>
              </tr>
              <tr>
                <td>61</td>
                <td>ABUBSAHAR</td>
                <td>SUSHIL KUMAR</td>
                <td>DPL</td>
                <td>9896712513</td>
                <td>Near Bus Stand, Abubsahar</td>
              </tr>
              <tr>
                <td rowspan="18">BHIWANI</td>
                <td>62</td>
                <td>SONEPAT</td>
                <td>VINAY</td>
                <td>DPL</td>
                <td>8053630177</td>
                <td>Shop No. 13,14,15, Chander Sekhar Azad Market, Sonepat</td>
              </tr>
              <tr>
                <td>63</td>
                <td>GANNAUR</td>
                <td>SURENDER SINGH</td>
                <td>DPL</td>
                <td>9813452999</td>
                <td>Opp. Railiway Station, Purkhas Road, Gannaur</td>
              </tr>
              <tr>
                <td>64</td>
                <td>GOHANA</td>
                <td>SATKAR</td>
                <td>DPL</td>
                <td>9813644262</td>
                <td>Outside New Anaj Mandi, Main Gohana-Jind Road, Gohana</td>
              </tr>
              <tr>
                <td>65</td>
                <td>KHARKHODA</td>
                <td>MANDEEP</td>
                <td>DPL</td>
                <td>8053630177</td>
                <td>Opp. New Grain Market, Sampla Road, Kharkhoda</td>
              </tr>
              <tr>
                <td>66</td>
                <td>JHAJJAR</td>
                <td>RAKESH </td>
                <td>DPL</td>
                <td>8221849630</td>
                <td>Kisan Sadan Near Veterinary Hospital, Jhajjar</td>
              </tr>
              <tr>
                <td>67</td>
                <td>BAHADURGARH</td>
                <td>HARDEEP</td>
                <td>DPL</td>
                <td>8930690070</td>
                <td>Near Grain Market Chowk, Nala Road, Bahadurgarh</td>
              </tr>
              <tr>
                <td>68</td>
                <td>ROHTAK</td>
                <td>ASHISH BALHARA</td>
                <td>DPL</td>
                <td>9416575146</td>
                <td>Near Old Bus stand, delhi-Hisar Road,Rohtak</td>
              </tr>
              <tr>
                <td>69</td>
                <td>KALANAUR</td>
                <td>ANUP SINGH</td>
                <td>M.A </td>
                <td>9812121010</td>
                <td>Near new Bus stand, Main Bhiwani-Rohtak Road, Kalanaur</td>
              </tr>
              <tr>
                <td>70</td>
                <td>SAMPLA</td>
                <td>SONIA</td>
                <td>PEON</td>
                <td>9817120833</td>
                <td>Old Mandi, bear Lilu Ram Flour Mill Sampla</td>
              </tr>
              <tr>
                <td>71</td>
                <td>KILOI</td>
                <td>SHIV KUMAR</td>
                <td>DPL</td>
                <td>9416666633</td>
                <td>Near Bus Stand, Kiloi</td>
              </tr>
              <tr>
                <td>72</td>
                <td>MEHAM</td>
                <td>SUNDER SINGH</td>
                <td>DPL</td>
                <td>9812590003</td>
                <td>New Grain Market, Booth No. 08, Meham</td>
              </tr>
              <tr>
                <td>73</td>
                <td>BHIWANI</td>
                <td>DHEERAJ</td>
                <td>PEON</td>
                <td>8684858601</td>
                <td>SCF No. 83, New Grain Market, Bhiwani</td>
              </tr>
              <tr>
                <td>74</td>
                <td>CH. DADRI</td>
                <td>SAJJAN SINGH</td>
                <td>DPL</td>
                <td>9991103018</td>
                <td>Near Old Bus Stand, Ch. Dadri</td>
              </tr>
              <tr>
                <td>75</td>
                <td>BAUND KALAN</td>
                <td>NARENDER KUMAR</td>
                <td>DPL</td>
                <td>9992067217</td>
                <td>Near Bus Stand, Baund Kalan</td>
              </tr>
              <tr>
                <td>76</td>
                <td>BADHRA</td>
                <td>BAJRANG LAL</td>
                <td>M.A</td>
                <td>9992261006</td>
                <td>Near Ice Factory, Dadri Road, Badhra</td>
              </tr>
              <tr>
                <td>77</td>
                <td>LOHARU</td>
                <td>SANJAY KUMAR</td>
                <td>DPL</td>
                <td>9991557705</td>
                <td>Near Railway Road, Opp. PWD Rest House, Loharu</td>
              </tr>
              <tr>
                <td>78</td>
                <td>BEHAL</td>
                <td>SUNIL</td>
                <td>DPL</td>
                <td>9812924079</td>
                <td>Near Haryana Gramin Bank & Opp. Bus Stand, Behal</td>
              </tr>
              <tr>
                <td>79</td>
                <td>SIWANI</td>
                <td>UMESH</td>
                <td>CLERK</td>
                <td>9991701922</td>
                <td>
                  Near SBI Bank Opp. Kedia Dharmashala, Railway road Siwani
                  Mandi
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ListofSaleCounters;
